import { render, staticRenderFns } from "./BusinessNameAttachments.vue?vue&type=template&id=6be658ce&scoped=true&"
import script from "./BusinessNameAttachments.vue?vue&type=script&lang=js&"
export * from "./BusinessNameAttachments.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameAttachments.vue?vue&type=style&index=0&id=6be658ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be658ce",
  null
  
)

export default component.exports